
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="名称" prop="names">
                <Input type="text" v-model="formData.names"></Input>
            </FormItem>
            <FormItem label="别名" prop="alias">
                <Input type="text" v-model="formData.alias"></Input>
            </FormItem>
            <FormItem label="内容" prop="values">
                <Input type="text" v-model="formData.values"></Input>
            </FormItem>
            <FormItem label="排序" prop="sorting">
                <Input type="text" v-model="formData.sorting"></Input>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
  },
  data() {
    return {
      title: "添加/编辑",
      disabled: false,
      defaultData:{
        id: '',
        names: "",
        alias: "",
        values: "",
        sorting: "",
      },
      formData: {},
      ruleCustom: {
        //验证
        names: [
          { required: true, message: "名称必须填写", trigger: "blur" },
        ],
        alias: [
          { required: true, message: "别名必须填写", trigger: "blur" },
        ],
        values: [
          { required: true, message: "内容必须填写", trigger: "blur" },
        ],
        sorting: [
          { required: true, message: "排序必须填写", trigger: "blur" },
        ],
       
      },
      
    };
  },
  watch: {
    showModel(val) {
		if(val){
			if (this.type && this.type == 2) {
				this.editForm()
			}
			if(this.type && this.type == 1){
				this.formData = this.defaultData
			}
		}
    },
  },
  methods: {
    editForm() {
	  for(let key in this.defaultData){
		  this.defaultData[key]=(this.editFormData[key] instanceof Array || this.editFormData[key] instanceof Object )?this.editFormData[key] : String(this.editFormData[key])
		  if(!this.editFormData[key]){
		    this.defaultData[key] = ''
		  } 
	      
	  }
      this.formData = this.defaultData;
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.axios
            .post(this.config.urlArray.configsStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm()
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
        this.defaultData = {
            id: '',
            names: "",
            alias: "",
            values: "",
            sorting: "",
        }
      //重置表单
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model{
    position: relative;
    .img-div{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 45px;
        div{
            font-weight: bold;
            font-size: 15px;
        }
    }
    .close-img{
        border: 1px solid #fd6363;
        display: inline-block;
        line-height: 100%;
        border-radius: 100%;
        padding: 5px;
        color: #f00;
        right: 10px;
        top: 10px;
        z-index: 3;
        cursor: pointer;
    }
    .close-img:hover{
        transform: scale(1.1);
        transition: all 0.3s;
    }
}
</style>